import { Reducer } from '@reduxjs/toolkit';
import { FluxStandardAction } from 'redux-promise-middleware';
import {
  AccountConfigurationFilter,
  AccountConfigurationEBP,
  AccountConfigurationList,
} from '../../../types/account_configurations';
import { getPageLimit } from '../../utils/Utils';

export interface ConfigurationsState {
  filters: {
    data: AccountConfigurationFilter[];
    isLoading: boolean;
    page: number;
    hasMoreData: boolean;
  };
  ebps: {
    data: AccountConfigurationEBP[];
    isLoading: boolean;
  };
  dynamicFieldLists: {
    data: AccountConfigurationList[];
    isLoading: boolean;
  };
}

const initialState: ConfigurationsState = {
  filters: {
    data: [],
    isLoading: false,
    page: 1,
    hasMoreData: true,
  },
  ebps: {
    data: [],
    isLoading: false,
  },
  dynamicFieldLists: {
    data: [],
    isLoading: false,
  },
};

const reducer: Reducer<ConfigurationsState, FluxStandardAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'FETCH_ACCOUNT_FILTERS_PENDING': {
      return {
        ...state,
        filters: {
          ...state.filters,
          isLoading: true,
        },
      };
    }
    case 'FETCH_ACCOUNT_FILTERS_FULFILLED': {
      const newData: AccountConfigurationFilter[] = action.payload.data;
      const page = action.meta?.page || 1;
      const pageLimit = getPageLimit();

      return {
        ...state,
        filters: {
          ...state.filters,
          data: page === 1 ? newData : [...state.filters.data, ...newData],
          isLoading: false,
          page,
          hasMoreData: newData.length >= pageLimit,
        },
      };
    }
    case 'FETCH_ACCOUNT_FILTERS_REJECTED': {
      return {
        ...state,
        filters: {
          ...state.filters,
          isLoading: false,
        },
      };
    }
    case 'FETCH_ACCOUNT_EBPS_PENDING': {
      return {
        ...state,
        ebps: {
          ...state.ebps,
          isLoading: true,
        },
      };
    }
    case 'FETCH_ACCOUNT_EBPS_FULFILLED': {
      return {
        ...state,
        ebps: {
          ...state.ebps,
          data: action.payload.data,
          isLoading: false,
        },
      };
    }
    case 'FETCH_ACCOUNT_EBPS_REJECTED': {
      return {
        ...state,
        ebps: {
          ...state.ebps,
          isLoading: false,
        },
      };
    }
    case 'FETCH_ACCOUNT_DYNAMIC_LISTS_PENDING': {
      return {
        ...state,
        dynamicFieldLists: {
          ...state.dynamicFieldLists,
          isLoading: true,
        },
      };
    }
    case 'FETCH_ACCOUNT_DYNAMIC_LISTS_FULFILLED': {
      return {
        ...state,
        dynamicFieldLists: {
          ...state.dynamicFieldLists,
          data: action.payload.data,
          isLoading: false,
        },
      };
    }
    case 'FETCH_ACCOUNT_DYNAMIC_LISTS_REJECTED': {
      return {
        ...state,
        dynamicFieldLists: {
          ...state.dynamicFieldLists,
          isLoading: false,
        },
      };
    }
  }
  return state;
};

export default reducer;
